const Alert = {
  parts: ["container"],
  defaultProps: {
    variant: "left-accent",
    pr: 8,
  },
};

export default Alert;
